import { cloneDeep } from 'lodash';

import constants from '@/utils/constants';

import GlobalConstants from './globalConstant';

const { PV_STATE, KYC_STEPS, KYC_STATUS, MERCHANT_PROFILE_KEY } =
	GlobalConstants;
const { ONBOARDING_STAGE } = constants;

const translatePVStatusToMO = (section) => {
	if (!section) {
		return KYC_STATUS.PENDING;
	}
	// Converting NOT_STARTED to PENDING
	switch (section.workflowStepState) {
		case PV_STATE.NOT_STARTED:
			return KYC_STATUS.PENDING;
		case PV_STATE.SUCCESS:
			return KYC_STATUS.COMPLETED;
		case PV_STATE.FAILURE:
			return KYC_STATUS.ERROR;
		case PV_STATE.ABORTED:
			return KYC_STATUS.ERROR;
		default:
			return section.workflowStepState;
	}
};

const transformKycStatusData = (kycData, kycStatusState, onboardingStage) => {
	const { journeys = [], kycSteps = [] } = kycData;
	// Parsing MO journey status data
	const businessDetails = journeys.find(
		(journey) => journey.type === KYC_STEPS.BUSINESS_DETAILS,
	);
	const kycCompletedStep = journeys.find(
		(journey) => journey.type === KYC_STEPS.KYC_COMPLETED,
	);
	// Parsing PV status data
	let bankSection;
	let gstSection;
	let documentSection;

	kycSteps.forEach((step) => {
		switch (step.profileStepMappingId) {
			case KYC_STEPS.BANK_SECTION:
				bankSection = step;
				break;
			case KYC_STEPS.GST_PAN_SECTION:
				gstSection = step;
				break;
			case KYC_STEPS.GST_PAN_DOCUMENT_UPLOAD_SECTION:
				documentSection = step;
		}
	});

	const kycStatusStateCopy = cloneDeep(kycStatusState);
	// Setting Business details section status
	kycStatusStateCopy[KYC_STEPS.BUSINESS_DETAILS].status = businessDetails.state;

	// Setting Bank Section status
	kycStatusStateCopy[KYC_STEPS.BANK_SECTION].status =
		translatePVStatusToMO(bankSection);

	// Setting GST section status
	kycStatusStateCopy[KYC_STEPS.GST_PAN_SECTION].status =
		translatePVStatusToMO(gstSection);

	// Setting Documents section status
	let docUploadStatus = translatePVStatusToMO(documentSection);
	// This check is to handle if merchant documents are verified but still he is not active. Combining activation step along with document verification step
	if (
		docUploadStatus === KYC_STATUS.COMPLETED &&
		onboardingStage !== ONBOARDING_STAGE.ACTIVE
	) {
		docUploadStatus = PV_STATE.PSEUDO_SUCCESS;
	}
	kycStatusStateCopy[KYC_STEPS.GST_PAN_DOCUMENT_UPLOAD_SECTION].status =
		docUploadStatus;

	const sectionList = Object.keys(kycStatusStateCopy);

	for (let i = 0; i < sectionList.length; i++) {
		// If a step is in IN_PROGRESS state then there is no need
		if (kycStatusStateCopy[sectionList[i]].status === KYC_STATUS.IN_PROGRESS) {
			break;
		}
		// If a current step is in error state and next step is pending, then the next step should not become in progress.
		if (
			kycStatusStateCopy[sectionList[i]].status === KYC_STATUS.ERROR &&
			i < sectionList.length - 1 &&
			kycStatusStateCopy[sectionList[i + 1]].status === KYC_STATUS.PENDING
		) {
			break;
		}
		// Setting first state which in in pending state as in progress
		if (kycStatusStateCopy[sectionList[i]].status === KYC_STATUS.PENDING) {
			kycStatusStateCopy[sectionList[i]].status = KYC_STATUS.IN_PROGRESS;
			break;
		}
	}
	return {
		kycStatusData: kycStatusStateCopy,
		kycCompleted:
			kycCompletedStep && kycCompletedStep.state === KYC_STATUS.COMPLETED,
	};
};

const getMerchantId = () => {
	const merchantData = JSON.parse(localStorage.getItem(MERCHANT_PROFILE_KEY));
	if (merchantData && merchantData.merchantId) {
		return merchantData.merchantId;
	}
	return null;
};

const getBrowserNameWithVersion = () => {
	const ua = navigator.userAgent;
	let tem;
	let M =
		ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
		[];
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return `IE ${tem[1] || ''}`;
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
		if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
	}
	M = M[2] ? [M[1], M[2]] : ['-'];
	const versionMatch = ua.match(/version\/(\d+)/i);
	if (versionMatch) {
		M.splice(1, 1, versionMatch[1]);
	}
	return M.join(' ');
};

export { transformKycStatusData, getMerchantId, getBrowserNameWithVersion };
